import React from "react";
import PropTypes from "prop-types";
import { Col, FormGroup, FormInput, Row } from "shards-react";
import AdviceText from "../../advice-text-component/AdviceText";

import "./type-input-component.css";

const GuidedInput = ({
    name,
    advicetext,
    inputPlaceholder,
    inputLabel,
    helptext,
    onChange,
    valid,
    invalid,
    value,
    inputType,
    showerror,
    required,
    readOnly
}) => {
    return (
        <FormGroup>
            <label className="type-input-component--label">{inputLabel}</label>
            <AdviceText
                showerror={showerror}
                text={advicetext}
                color={"#8C0E0E"}
            />
            <Row>
                <Col sm={12} md="6" lg="6">
                    <FormInput
                        name={name}
                        value={value}
                        readOnly={readOnly}
                        placeholder={inputPlaceholder}
                        valid={valid}
                        invalid={invalid}
                        onChange={onChange}
                        type={inputType}
                        required={required}
                    />
                </Col>
                <Col sm={12} md={6} lg={6}>
                    <div className="h-100 w-100 d-flex align-items-center">
                        <p className="m-0">{helptext}</p>
                    </div>
                </Col>
            </Row>
        </FormGroup>
    );
};

GuidedInput.propTypes = {
    options: PropTypes.object,
    isAdmin: PropTypes.bool,
    miniApp: PropTypes.object,
    inputPlaceholder: PropTypes.string,
    inputLabel: PropTypes.string,
    name: PropTypes.string,
    advicetext: PropTypes.string,
    helptext: PropTypes.string,
    isEditScreen: PropTypes.bool,
    showInputError: PropTypes.bool,
    onChange: PropTypes.func,
    valid: PropTypes.bool,
    invalid: PropTypes.bool,
    value: PropTypes.string,
    showerror: PropTypes.bool,
    inputType: PropTypes.string,
    required: PropTypes.bool,
    readOnly: PropTypes.bool
};

export default GuidedInput;
